import moment from "moment";

export const dateFormat1 = (d: Date | string) => moment(d).utc().format("DD MMMM YYYY");
